export const LocalStorageKeys = {
  idleTimer : 'idleTimer',
  preferencePageSize : 'preferencePageSize',
  user : 'user'
}